import React from 'react';
import {Row,Col,Typography} from 'antd';
import EmptyTable from "./EmptyTable.svg";
const {Title,Text}= Typography;
export default function EmptyState() {
    return (
        <Row justify="center" align="middle" style={{marginTop:'0.5em', minHeight:'20em',border: "1px solid #E6E7E7"}}>
            <Col span={24}>
           <Row justify="center">
           <img src={EmptyTable} alt="EmptyTable"  />
           </Row>
            
           <Row justify="center" style={{marginTop:'1em'}}>
           <Title level={5}>Variant type not selected</Title>
           </Row>
           <Row justify="center">
           <Text>Select the variants from the drop down and click on ‘Save’ above to enter details</Text>
           </Row>

            </Col>
        </Row>
    )   
}
